import React, { Component } from 'react';
import { Row } from '../basic';
import _ from 'lodash';
import { proxy } from '../../helpers/util';
import { findDOMNode } from 'react-dom';
import * as  eChartCommon from '../echart/eChartCommon';
import { getPredicateValue, getRoundValue } from '../../helpers/util';
import TotalContainerOld from './TotalContainerOld';
export default class TotalContainer extends Component {
  //   render() {
  //     const { billnum, viewModel } = this.props;
  //     // const controlModel = viewModel.get(meta.cCode);
  //     return (
  //       <Total billnum={billnum} viewModel={viewModel} />
  //     );
  //   }
  // }

  // class Total extends Component {

  constructor(props) {
    super(props);
    let bPublished = this.props.viewid ? true : false;
    this.state = {
      billnum: props.billnum ? props.billnum : this.props.viewModel.getParams().billNo,
      totalFields: {},
      condition: {},
      controls: [],
      bDisplaySumField: true,
      bPublished,
      firstQueryDone: false
    };
    this.canMove = false;
    this.maxMoveLen = 0;
  }
  componentDidMount() {
    let self = this;
    self.props.viewModel.on('firstQueryDone', (params) => {
      // if (params == true) {
      self.state.firstQueryDone = params;
      // }
    });
    self.props.viewModel.on("filterClick", (params) => {
      self.state.condition = params.condition;
      self.getSum();
    });
    self.props.viewModel.on("saveSumArea", (params) => {
      self.state.bDisplaySumField = true;
      self.getTotalFields(self.state.billnum, true);
    });
    if (cb.isInTouchReport(self.props.viewModel)) {
      this.setTouchEvent();
    }
    if (self.state.billnum) {
      self.getTotalFields(self.state.billnum)
    }
    if (!this.refs.totalContainer) return;
    let dom = findDOMNode(this.refs.totalContainer);
    if (!dom) return;
    this.height = dom.clientHeight;
    this.props.viewModel.execute('totalHeightUpdate', this.height);

  }

  isInElement(ele, parentId) {
    let parent = ele;
    let bFlag = false;
    for (let i = 1; i <= 6 && bFlag == false && parent; i++) {
      if (parent.id == parentId)
        bFlag = true;
      else {
        parent = parent.parentElement;
      }
    }
    return bFlag;

  }

  setTouchEvent() {
    let self = this;
    var pageX, initX, isTouch = false;
    var beginX = 0;
    let eventName1 = "";
    let eventName2 = "";
    let eventName3 = "";
    if (cb.isTest_Touch == true) {
      eventName1 = "mousedown";
      eventName2 = "mousemove";
      eventName3 = "mouseup";
    }
    else {
      eventName1 = "touchstart";
      eventName2 = "touchmove";
      eventName3 = "touchend";
    }
    document.addEventListener(eventName1, function (e) {
      let targetEle = document.getElementById("ID_TotalContainer_Inner");
      if (self.isInElement(e.target, 'ID_TotalContainer_Inner') && self.canMove == true) {
        if (cb.isTest_Touch == true) {
          pageX = e.clientX;
          beginX = (targetEle.style.marginLeft || "0").replace("px", "");
          isTouch = true;
        }
        else {
          pageX = e.targetTouches[0].pageX;
          beginX = (targetEle.style.marginLeft || "0").replace("px", "");
          isTouch = true;
        }
      }
    }, false);

    //监听 touchmove 事件 手指 移动时 做的事情
    document.addEventListener(eventName2, function (e) {
      let targetEle = document.getElementById("ID_TotalContainer_Inner");
      if (isTouch && self.isInElement(e.target, 'ID_TotalContainer_Inner') && self.canMove == true) {
        if (cb.isTest_Touch == true) {
          var touchMoveX = e.clientX;
          let movedX = beginX - pageX + touchMoveX;
          if (movedX < 0 && movedX > 0 - self.maxMoveLen) {
            targetEle.style.marginLeft = movedX + "px";
          };
        } else {
          var touchMoveX = e.targetTouches[0].pageX;
          let movedX = beginX - pageX + touchMoveX;
          if (movedX < 0 && movedX > 0 - self.maxMoveLen) {
            targetEle.style.marginLeft = movedX + "px";
          };
        }
      }
    }, false);
    document.addEventListener(eventName3, function (e) {
      if (isTouch) {
        isTouch = false;
      }
    }, false);

  }

  // shouldComponentUpdate(nextProps, nextState) {
  // let self = this;
  // const { sumAreaState, sumAreaRedux } = this.props;
  // let refreshNum = _.get(nextProps.sumAreaState, "refreshNum");
  // if (refreshNum && refreshNum == this.state.billnum) {
  //   self.state.bDisplaySumField = true;
  //   this.getTotalFields(this.state.billnum, true);
  //   sumAreaRedux.SetRefreshNum("");
  // }
  // return true;
  // }
  getTotalFields(billnum, bReGet) {
    let self = this;
    if ((bReGet || _.isEmpty(self.state.totalFields)) && !!billnum && self.state.bDisplaySumField) {
      let totalFields = {};
      let param = { billnum, isOnlySelected: true };
      let callback = (json) => {
        if (json.code === 200) {
          if (json.data) {
            let items = json.data.items;
            items.forEach((ele) => {
              let caption = ele.showCaption ? ele.showCaption : ele.caption;
              if(ele.columnDefine && ele.columnDefine != "{}"){
                ele.columnDefine = JSON.parse(ele.columnDefine);
                let bShowIt = ele.columnDefine.bShowIt
                if(bShowIt == "false"){
                  ele.selected = 0;
                  ele.columnDefine = JSON.stringify(ele.columnDefine)
                }
              }
              if (ele.selected) {
                const totalField = { caption: caption, value: 0 };
                totalFields[ele.fieldname] = totalField;
              }
            });
            if (_.isEmpty(totalFields)) {
              self.setState({ bDisplaySumField: false });
              return;
            }
            self.state.totalFields = totalFields;
            self.getSum();
          };
        }
        else {
          eChartCommon.LogChartInfo("TotalContainer getTotalFields Err  errMsg   ", json.message + " 查询参数 = " + JSON.stringify(param), 999);
        }
      }
      this.actionsProxy('report/getTotalSetting', 'GET', param, callback);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!this.refs.totalContainer) return;
    let dom = findDOMNode(this.refs.totalContainer);
    if (!dom) return;
    if (this.height != dom.clientHeight) {
      this.height = dom.clientHeight;
      this.props.viewModel.execute('totalHeightUpdate', this.height);
    }

    if (nextProps.billnum !== "" && this.state.billnum != nextProps.billnum) {
      this.state.billnum = nextProps.billnum;
      this.getTotalFields(nextProps.billnum);
    }
  }


  getSum() {

    let self = this;
    
    let canFilter = {value: true};
    self.props.viewModel.execute("beforeTotalFilter",{canFilter})
    if(!canFilter.value){
      return;
    }
    if (_.isEmpty(self.state.billnum))
      return;
    if (_.isEmpty(self.state.condition))
      return;
    if (_.isEmpty(self.state.totalFields))
      return;

    if (!self.state.firstQueryDone) {
      self.setSum({});
      return;
    }
    let queryParams = {
      billnum: self.state.billnum,
      isOnlyTotal: true,
      condition: self.state.condition
    };
    if (this.state.bPublished) {
      queryParams.viewid = this.props.viewid;
    }
    let callback = (json) => {
      if (json.code === 200) {
        let data = json.data.sumRecordList;
        if (data == null || (data.length == 1 && data[0] == null))
          data = [{}];
        let fields = _.get(json.data, "viewmodel.entities[0].fields");
        if (!fields)
          fields = self.props.viewModel.getGridModel() && self.props.viewModel.getGridModel().getColumns();
        self.setSum(data, fields);
      }
      else {
        self.setSum({});
      }
    }
    this.actionsProxy('/report/list', 'POST', queryParams, callback);
  }
  formatData(fieldName, fieldValue, fields) {
    let formatter = undefined;
    if (isNaN(fieldValue)) return fieldValue;
    let fieldEle = _.find(fields, function (o) { return o.cItemName == fieldName });
    /*谓词变量支持系统参数*/
    if (!fieldEle) {
      return fieldValue;
    }
    let cFormatData = fieldEle.cFormatData;
    try {
      if (!cFormatData || cFormatData == '') {
        cFormatData = {};
      } else {
        cFormatData = JSON.parse(cFormatData);
      }
    } catch (e) {
      // cb.utils.alert('数量/金额/单价，预制错误！', 'error');
      return fieldValue;
    }
    let iNumPoint = fieldEle.iNumPoint;
    let decimal = cFormatData.decimal ? getPredicateValue(cFormatData.decimal) : null;
    let controlType = fieldEle.cControlType;
    if (controlType === 'money') {
      formatter = value => {
        let _value = (value + '');
        let _valueArr = _value.split('.');
        if (_valueArr.length == 1) {
          return `${_value.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
        } else {
          _valueArr[0] = _valueArr[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          return `${_valueArr.join('.')}`;
        }
      }
      if (decimal)
        iNumPoint = decimal;
      else
        iNumPoint = cb.rest.AppContext.option.amountofdecimal;
    } else if (controlType === 'price') {
      if (decimal)
        iNumPoint = decimal;
      else
        iNumPoint = cb.rest.AppContext.option.monovalentdecimal;
    } else {
      if (decimal)
        iNumPoint = decimal;
      else
        if (cb.utils.isEmpty(iNumPoint)) iNumPoint = null;
    }
    if (!isNaN(iNumPoint) && iNumPoint != null) {
      fieldValue = parseFloat(fieldValue);
      fieldValue = getRoundValue(fieldValue, iNumPoint);
    }
    if (formatter) {
      fieldValue = formatter(fieldValue)
    }
    if (cFormatData.after)
      fieldValue = fieldValue + cFormatData.after;
    return fieldValue;
  }

  setSum(sumData, fields) {
    let self = this;
    if (_.isEmpty(sumData)) sumData = [{}];
    if (!sumData.length) sumData = [{}];
    const controls = [];
    _.forEach(self.state.totalFields, (item, key) => {
      let value = sumData[0][key] || 0;
      value = self.formatData(key, value, fields);
      controls.push({ caption: item.caption, value: value });
    });
    self.setState({ controls });
  }

  getEleWidth(eleID) {
    let ele = document.getElementById(eleID);
    if (ele && ele.clientWidth)
      return ele.clientWidth;
    else
      return 0;
  }

  getControlsWidth() {
    let arr = document.getElementsByClassName("rpt-zhekou-list-out");
    let width = 0;
    let arr2 = Object.values(arr);
    arr2 && arr2.length > 0 && arr2.forEach((ele) => {
      width = width + ele.offsetWidth;
    });
    if (width == 0)
      width = 100;
    return width;
  }

  render() {
    const { controls } = this.state;
    let self = this;
    this.canMove = false;

    if (self.state.bDisplaySumField == false)
      return null;
    if (!controls.length) {
      //如果不存在新的汇总区域设置，则使用旧的
      return <TotalContainerOld ref={'total'} meta={self.props.meta} viewModel={self.props.viewModel} />;
    }
    const itemClassName = `rpt-zhekou-${controls.length === 1 ? 'padding' : 'center'}`;
    const children = [];
    let childrenStyle = { float: 'left', width: (100 / controls.length) + '%' };
    this.controlsWidth = this.getControlsWidth();
    if (cb.isInTouchReport(self.props.viewModel)) {
      childrenStyle = { float: 'left' };
      try {
        let tmpWidth = self.getEleWidth("ID_TotalContainer");
        if (tmpWidth > 0 && this.controlsWidth > tmpWidth) {
          this.canMove = true;
          this.maxMoveLen = this.controlsWidth - tmpWidth;
          childrenStyle.flexShrink = 0;
        }
      }

      catch (e) { }
    }
    controls.forEach(item => {
      let tmp = <div className="rpt-zhekou-list" style={childrenStyle}>
        <div className="zhekou-name"><h3 className={itemClassName}>{item.caption}</h3></div>
        <div className="zhekou-number"><h4 className={itemClassName}>{cb.utils.formatAmount(item.value)}</h4></div>
      </div>;
      if (cb.isInTouchReport(self.props.viewModel)) {
        tmp = <div className="rpt-zhekou-list-out">{tmp}  </div>
      }
      children.push(tmp);
    });
    if (cb.isInTouchReport(self.props.viewModel)) {
      return <Row id="ID_TotalContainer" ref="totalContainer" className="rpt-zhekou totalContainer_TouchRptCls">
        <div id="ID_TotalContainer_Inner" style={{ display: "flex", overflow: "hidden", marginLeft: 0 }}>
          {children}
        </div>
      </Row>;
    }
    else {
      return <Row ref="totalContainer" className="rpt-zhekou">{children}</Row>;
    }
  }

  actionsProxy(url, method, params, callback) {
    const config = { url: url, method: method, params: params };
    proxy(config)
      .then(json => {
        callback(json);
      });
  }
  componentDidUpdate(prevProps, prevState) {
    if (cb.isInTouchReport(this.props.viewModel)) {
      let controlsWidth2 = this.getControlsWidth();
      if (this.controlsWidth && this.controlsWidth != controlsWidth2) {
        this.forceUpdate();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/meta/TotalContainer.jsx